import { Amount } from '@/types/amount';
import { Locale } from '@/types/locale';
import { toValidCurrency } from '@/utility/currencies';
import { numbersLocale } from '@/utility/numbersLocale';

const format = (locale: Locale, amount: Amount): string => {
  // For USD-based currencies, use custom formatting to avoid spaces
  if (
    amount.currencyCode === 'USDC' ||
    amount.currencyCode === 'USDT' ||
    amount.currencyCode === 'USD'
  ) {
    const numberFormatter = new Intl.NumberFormat(numbersLocale(locale), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const formattedNumber = numberFormatter.format(amount.value ?? 0);
    return `$${formattedNumber} ${amount.currencyCode}`;
  }

  // For other currencies, use standard formatting
  const formatter = new Intl.NumberFormat(numbersLocale(locale), {
    style: 'currency',
    currency: toValidCurrency(amount.currencyCode),
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount.value ?? 0);
};

export const transactionFromToAmount = (locale: Locale, from: Amount, to: Amount): string =>
  `${format(locale, from)} \u2192 ${format(locale, to)}`;
